import React, { useState } from 'react'
import DatePicker from 'react-datepicker';
import Select from 'react-select'

export default function Credits({player, histories, onUpdateCredit}) {
  const [addCredit, setAddCredit] = useState(null)
  const [reduceCredit, setReduceCredit] = useState(null)
  const [credit, setCredit] = useState(0)
  const [reason, setReason] = useState('')
  const [expirationDate, setExpirationDate] = useState(moment().add(6, 'month'))
  const [category, setCategory] = useState('payment')

  const updateCredit = (type, value) => {
    if (value < 0) return
    if (type == 'reduce' && value > Number(player.credit)) return

    setCredit(value)
  }

  const transactionType = (amount, description) =>{
    const transactioTypes = {
      'Manually added': 'Assigned',
      'Manually reduced': 'Reduced'
    }

    return transactioTypes[description] || (amount > 0 ? 'Assigned' : 'Reduced')
  }

  const onAddCreditOpen = () => {
    setAddCredit(true)
    setReduceCredit(false)
    setCredit(0)
    setReason('')
    setCategory('payment')
  }

  const onReduceCreditOpen = () => {
    setReduceCredit(true)
    setAddCredit(false)
    setCredit(0)
    setReason('')
    setCategory('payment')
  }

  return <div>
    <div>
      <button className='btn btn-primary' onClick={onAddCreditOpen}>
        Add Credits +
      </button>
      <button className='btn btn-primary ml' onClick={onReduceCreditOpen}>
        Reduce Credits -
      </button>
    </div>
    {reduceCredit &&
      <div className='reduce-section'>
        <div className='row'>
          <div className='col-md-2 player-profile-label'>Game credits</div>
          <div className='col-md-2'>
            <input
              className='form-control'
              name='player-credits-input'
              type='number'
              step='0.01'
              value={credit}
              onChange={e => updateCredit('reduce', e.target.value)}
            />
          </div>
        </div>
        <div className='row add-section__category'>
          <div className='col-md-2 player-profile-label'>Category</div>
          <div className='col-md-10'>
            <select
              className='form-control'
              value={category}
              onChange={e => setCategory(e.target.value)}>
              { ['payment', 'reward'].map((o, i) => <option key={i} value={o}>{o.charAt(0).toUpperCase() + o.slice(1)}</option> )}
            </select>
          </div>
        </div>
        <div className='row add-section__reason'>
          <div className='col-md-2 player-profile-label'>Reason</div>
          <div className='col-md-10'>
            <textarea
              rows='3'
              name='history-description'
              className='form-control'
              value={reason}
              onChange={e => setReason(e.target.value)}
            />
          </div>
        </div>
        <div className='row add-section__save-button'>
          <div className='col-md-2'></div>
          <div className='col-md-2'>
            <button
              disabled={credit == 0 || reason.length == 0}
              className='btn btn-primary'
              onClick={() => onUpdateCredit((Number(player.credit) - Number(credit)).toFixed(2), reason, expirationDate, category)}>
              Save
            </button>
          </div>
        </div>
      </div>
    }
    {addCredit && <div className='add-section'>
      <div className='row'>
        <div className='col-md-2 player-profile-label'>Game credits</div>
        <div className='col-md-2'>
          <input
            className='form-control'
            name='player-credits-input'
            type='number'
            step='0.01'
            value={credit}
            onChange={(e) => {updateCredit('add', e.target.value)}}
          />
        </div>
      </div>
      <div className='row add-section__expiration-date'>
        <div className='col-md-2 player-profile-label'>Expiration date</div>
        <div className='col-md-10'>
          <label onClick={e => e.preventDefault()}>
            <DatePicker
              className='form-control'
              minDate={moment()}
              onChange={(e) => setExpirationDate(e)}
              selected={expirationDate}
            />
          </label>
        </div>
      </div>
      <div className='row add-section__category'>
        <div className='col-md-2 player-profile-label'>Category</div>
        <div className='col-md-10'>
          <select
            className='form-control'
            value={category}
            onChange={e=> setCategory(e.target.value)}>
            { ['payment','reward'].map((o, i) => <option
              key={i} value={o}>{o.charAt(0).toUpperCase() + o.slice(1)}</option>) }
          </select>
        </div>
      </div>
      <div className='row add-section__reason'>
        <div className='col-md-2 player-profile-label'>Reason</div>
        <div className='col-md-10'>
          <textarea
            rows='3'
            name='history-description'
            className='form-control'
            placeholder='Request for inviting friend (required)'
            value={reason}
            onChange={(e) => {setReason(e.target.value)}}
          />
        </div>
      </div>
      <div className='row add-section__save-button'>
        <div className='col-md-2'></div>
        <div className='col-md-2'>
          <button
            disabled={credit == 0 || reason.length == 0}
            className='btn btn-primary'
            onClick={()=>onUpdateCredit((Number(player.credit) + Number(credit)).toFixed(2),
              reason, expirationDate, category)}>
            Save
          </button>
        </div>
      </div>
    </div>}
    {histories && histories.length > 0 && <div>
      <div className='row text-lg-left credit-history-title'>
        Credit history ({player.credit} active credits)
      </div>
      <div className='row player-portal__table'>
        <div className='col-lg-12'>
          <table className='table table-bordered table-hover text-center'>
            <thead>
            <tr>
              <th>Date</th>
              <th>Transaction type</th>
              <th>Amount</th>
              <th>Description</th>
              <th>Expiration Date</th>
              <th>Category</th>
            </tr>
            </thead>
            <tbody>
            {histories.map((history, index) =>
              <tr key={index}>
                <td>{history.date}</td>
                <td>{transactionType(history.amount, history.description)}</td>
                <td>{Math.abs(history.amount)}</td>
                <td>{history.description}</td>
                <td>{history.expiration_date}</td>
                <td>{history.category}</td>
              </tr>
            )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
    }
  </div>
}
